export const COOKIE_NAME_USER_LANGUAGE = 'user_language';
